/* src/app/builder-screen-beta/help/feature-guide.component.scss */
.feature-guide-content {
  max-height: 70vh;
  overflow-y: auto;
}
.feature-guide-content .feature-description {
  padding: 16px 0;
}
.feature-guide-content .feature-description p {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.6;
}
.feature-guide-content .feature-description ul {
  margin: 12px 0;
  padding-left: 0;
}
.feature-guide-content .feature-description ul li {
  list-style: none;
  padding: 6px 0;
  font-size: 13px;
  line-height: 1.5;
}
.feature-guide-content .feature-description ul li strong {
  color: #1890ff;
}
.feature-guide-content .feature-description .ant-tag {
  margin-top: 12px;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
}
.guide-footer {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
:host ::ng-deep .ant-steps-vertical .ant-steps-item-content {
  min-height: auto;
  padding-bottom: 16px;
}
:host ::ng-deep .ant-steps-item-title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}
:host ::ng-deep .ant-steps-item-icon {
  width: 28px;
  height: 28px;
  line-height: 28px;
}
:host ::ng-deep .ant-steps-item-icon .anticon {
  font-size: 14px;
}
:host ::ng-deep .ant-alert .ant-alert-message {
  font-weight: 600;
  color: #1890ff;
}
:host ::ng-deep .ant-alert .ant-alert-description {
  font-size: 13px;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .feature-guide-content {
    max-height: 60vh;
  }
  .feature-guide-content .feature-description {
    padding: 12px 0;
  }
  .feature-guide-content .feature-description ul li {
    font-size: 12px;
    padding: 4px 0;
  }
}
/*# sourceMappingURL=feature-guide.component.css.map */
